import React from "react";
import "./Financials.css";
import HeaderHome from "../../components/HeaderHome/HeaderHome";

function Financials() {
  const financials = [
    {
      year: 2025,
      link: "https://maxscholars.org/media/financial_statements/Final_FS_-_MAX_Scholarship_Fund_2025.12.31.pdf",
    },
    {
      year: 2024,
      link: "https://maxscholars.org/media/financial_statements/Final_FS_-_MAX_Scholarship_Fund_2024.12.31.pdf",
    },
    {
      year: 2023,
      link: "https://maxscholars.org/media/financial_statements/MSF_FS_and_T2.pdf",
    },
    {
      year: 2022,
      link: "https://maxscholars.org/media/financial_statements/Final_FS_-_MAX_Scholarship_Fund_2022.12.31.pdf",
    },
  ];

  return (
    <div>
      <HeaderHome title="" backgroundUrl="Financials.jpeg" />
      <div style={{ textAlign: "center", marginTop: "3em" }}>
        <h1
          style={{
            color: "#0260A8",
            fontWeight: "bold",
          }}
        >
          MSF Financials
        </h1>
      </div>
      <div className="centered-content">
        <p className="centered-text">
          Explore the financial journey of MAX Scholarship Fund (MSF) by delving
          into our detailed financial reports spanning the past three years.
          These reports provide a transparent overview of our fiscal management,
          showcasing our commitment to accountability and responsible
          stewardship of funds. Your engagement is valued as we strive for
          financial transparency and integrity in supporting educational
          opportunities.
        </p>
      </div>
      <div className="financials-list-container">
        <ul className="financials-list">
          {financials.map((item) => (
            <li key={item.year} className="financials-list-item">
              <span className="financials-year">{item.year}</span>
              <a
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                className="financials-download-link"
              >
                Download Financials
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default Financials;
